import React, { useState, useCallback } from "react";
import { debounce } from "lodash";
import { Controller } from "react-hook-form";
import BaseAutocomplete from "components/Shared/Base/BaseAutocomplete";
import { useLazySearchCustomersQuery } from "store/services/customerApi";

const SearchCustomer = ({
  control,
  name,
  label,
  required = false,
  disabled = false,
  error = false,
  helperText = "",
  accountId,
  entityId,
  excludeId = null,
  minLength = 4,
  onChange = () => { },
  onAddNew = () => { },
  showAddButton = true,
}) => {
  const [searchCustomers, { isLoading: loadingCustomers }] = useLazySearchCustomersQuery();
  const [customerSearchResults, setCustomerSearchResults] = useState([]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearchCustomers = useCallback(
    debounce(async (query) => {
      if (query && query.length >= minLength && accountId && entityId) {
        const result = await searchCustomers({ account: accountId, entity: entityId, query }).unwrap();
        setCustomerSearchResults(result?.data || []);
      } else {
        setCustomerSearchResults([]);
      }
    }, 2000),
    [accountId, entityId, searchCustomers, minLength]
  );

  return (
    <Controller
      name={name}
      control={control}
      rules={
        required ? { required: `Please select ${label.toLowerCase()}.` } : {}
      }
      render={({ field }) => (
        <BaseAutocomplete
          fullWidth
          label={label}
          required={required}
          loading={loadingCustomers}
          loadingText={`Searching ${label.toLowerCase()}...`}
          value={field.value || null}
          onChange={(_, data) => {
            field.onChange(data);
            onChange(data);
          }}
          onInputChange={(event, newInputValue) => {
            debouncedSearchCustomers(newInputValue);
          }}
          getOptionLabel={(option) =>
            option
              ? `${option.name || option.customerUser?.name || "Unknown"} - ${option.phone
              }`
              : ""
          }
          isOptionEqualToValue={(option, value) => option?._id === value?._id}
          options={
            excludeId
              ? customerSearchResults?.filter(
                (cust) => cust._id !== excludeId
              ) || []
              : customerSearchResults || []
          }
          disabled={disabled}
          helperText={helperText}
          error={error}
          noOptionsText={`Enter at lease 4 characters to search ${label} by Name or Phone`}
          PaperComponent={
            showAddButton
              ? (props) => (
                <BaseAutocomplete.PaperAddNew
                  {...props}
                  buttonLabel={`Add ${label}`}
                  onAddNew={onAddNew}
                />
              )
              : undefined
          }
        />
      )}
    />
  );
};

export default SearchCustomer;
